<template>
  <loader v-if="!asyncData"/>
  <dropdown-input
    v-else
    :data="asyncData"
    v-model="input"/>
</template>

<script>
import DropdownInput from './DropdownInput'
import Loader from '../Loader'
// import { APIError } from '../../helpers'

export default {
  name: 'AsyncDropdownInput',
  components: { DropdownInput, Loader },
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      required: true
    },
    functions: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      input: null,
      asyncData: null
    }
  },
  created () {
    this.initialize()
      .catch(
        error => {
          this.$rollbar.error(error.message, error.response)
          this.asyncData = { ...this.data, disabled: true, placeholder: this.data.errorMessage }
        }
      )
  },
  watch: {
    input: {
      handler: function (value) {
        this.$emit(
          'input',
          this.functions.hasOwnProperty('constructInput')
            ? this.functions.constructInput(this.input)
            : this.input
        )
      },
      deep: true
    }
  },
  methods: {
    async initialize () {
      let options = await this.functions.getOptions()

      this.input = (
        this.functions.hasOwnProperty('mapInputToOption')
          ? this.functions.mapInputToOption(options, this.value)
          : this.value
      )

      this.asyncData = { ...this.data, options }
    }
  }
}
</script>

<style scoped>

</style>
